import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import PC from './PC';
import WAP from './WAP';

function index(): JSX.Element {
    const { STATUS, Device } = useSelector(
        ({ IMReducer, IndexReducer }) => ({
            STATUS: IMReducer.STATUS,
            Device: IndexReducer.Device
        }),
        shallowEqual
    );
    const _handleClose = () => {
        if (STATUS.CLOSED) {
            IM.IMServer.notice(
                'warn',
                '会话已经结束，如需继续咨询请<span class="win-reload">重新连接客服</span>'
            );
            return;
        }
        IM.handlePopup({ popup: 'end', open: true });
    };

    return Device.isMobile ? <WAP close={_handleClose} /> : <PC close={_handleClose} />;
}

export default index;
